<template>
  <div class="list-container">
    <div class="list-grid">
      <div class="articleList" v-for="(article, idx) in paginatedData" :key="idx" @click="showArticle(article.id)">
        <div class="list-header">
          <div class="h-ic">
            <img src="../../assets/images/account.png" class="list-account" />
          </div>
          <div class="list-name"><b>익명</b></div>
        </div>
        <div v-if="article.smallContent === '' || articleId === article.id" class="list-body">
          {{ article.content }}
        </div>
        <div v-else>
          <div v-if="articleId !== article.id" class="list-bd" v-on:click="moreRead(article.id)">
            {{ article.smallContent
            }}<button class="moreRead" v-on:click="moreRead(article.id)">
              <b>더보기</b>
            </button>
          </div>
        </div>
        <div class="list-footer-body">
          <div class="list-footer">
            <div v-if="article.like !== 0" class="likeCount">좋아요 {{ article.like }}개</div>
            <div v-if="checkLike(article.id) == null" style="cursor: default !important;">
              <!-- 안눌렀으면 -->
              <div class="f-icon" @click="stopPropagation()" style="padding-left: 13px;">
                <img
                  class="icon"
                  src="../../../src/assets/images/like_blank.png"
                  @click="createLike(article)"
                />&nbsp;&nbsp;
              </div>
              <div class="f-icon">
                <img class="icon" src="../../../src/assets/images/comment.png" />
              </div>
            </div>
            <div v-else @click="stopPropagation()" style="cursor: default !important;">
              <!-- 눌렀으면 -->
              <div class="f-icon" @click="stopPropagation()" style="padding-left: 13px">
                <img class="icon" src="../../../src/assets/images/like.png" @click="createLike(article)" />&nbsp;&nbsp;
              </div>
              <div class="f-icon">
                <img class="icon" src="../../../src/assets/images/comment.png" @click="showArticle(article.id)" />
              </div>
            </div>
          </div>
          <div v-if="article.commentCount !== 0" class="commentCount">댓글 {{ article.commentCount }}개 모두보기</div>
          <div v-if="article.commentCount !== 0" class="list-comment">
            <span v-for="content in article.commentContent" v-bind:key="content" class="list-content">
              <span class="cc"
                ><b style="font-weight:900; font-size: 13px">익명</b>&nbsp;&nbsp;&nbsp;{{ content }}</span
              >
            </span>
          </div>
          <div class="list-updateDT">{{ article.createDT }}</div>
        </div>
      </div>
    </div>
    <!--        <div class="btn-cover">-->
    <!--          <button v-if="pageNum === 0" class="btn-preStop">pre</button> &lt;!&ndash;안눌림 &ndash;&gt;-->
    <!--          <button v-else class="btn-pre" v-on:click="prevPage">pre</button>-->

    <!--          <span v-for="page in pageCountList">-->
    <!--            <button v-if="pageNum == page - 1" class="btn-OnColor" v-on:click="onPage(page)">{{ page }}</button> &lt;!&ndash; 클릭된 페이지&ndash;&gt;-->
    <!--            <button v-else class="btn-on" v-on:click="onPage(page)">{{ page }}</button>-->
    <!--          </span>-->

    <!--          <button v-if="pageNum < pageCount - 1" class="btn-next" v-on:click="nextPage">next</button>-->
    <!--          <button v-else class="btn-nextStop">next</button> &lt;!&ndash; 마지막 페이지일 때 안눌림 &ndash;&gt;-->
    <!--        </div>-->
    <div class="btn">
      <button v-if="pageNum < pageCount" class="btn-next" v-on:click="nextPage">
        더보기
      </button>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app';
import { getTimeStamp } from '../../api';

export default {
  name: 'List',
  props: ['articleList', 'type'],
  data() {
    return {
      pageNum: 1,
      pageSize: 39,
      like: 0,
      unLike: 0,
      showMenu: false,
      articleId: 0,
    };
  },
  mounted() {},
  computed: {
    pageCount() {
      //전체 페이지 count
      let listLeng = Object.keys(this.articleList).length;
      let listSize = this.pageSize;
      let page = Math.floor(listLeng / listSize);
      if (listLeng % listSize > 0) page += 1;
      return page;
    },
    pageCountList() {
      //페이지네이션 번호 count
      let listLeng = Object.keys(this.articleList).length;
      let listSize = this.pageSize;
      let page = Math.floor(listLeng / listSize);
      if (listLeng % listSize > 0) page += 1;
      var start = Math.floor(this.pageNum / 10) * 10 + 1; //시작페이지
      var end = 0;
      if (Math.floor(page / 10) > Math.floor(this.pageNum / 10))
        //마지막페이지가 현재페이지 ~9보다 클때
        end = Math.floor(this.pageNum / 10) * 10 + 10;
      //마지막 페이지가 현재페이지일때
      else end = page;
      var pageList = [];
      for (var i = start; i <= end; i++) {
        pageList.push(i);
      }
      return pageList;
    },
    paginatedData() {
      const start = 0,
        end = this.pageNum * this.pageSize;
      return this.articleList.slice(start, end);
    },
  },
  methods: {
    stopPropagation() {
      event.stopPropagation();
    },
    showArticle: function(id) {
      // this.$router.push({ name: "Detail", query: { id:id } })
      // this.$router.push("/detail/" + id);
      this.$router.push({
        name: 'Detail',
        params: { id: id },
      });
    },
    nextPage() {
      this.$router.push({
        name: 'Home',
        query: { pg: String(this.pageNum + 1) },
      });
      this.pageNum += 1;
    },
    prevPage() {
      this.pageNum -= 1;
    },
    onPage(page) {
      this.pageNum = page - 1;
    },
    checkLike(id) {
      return localStorage.getItem(id);
    },
    createLike(article) {
      event.stopPropagation();
      let isLiked = localStorage.getItem(article.id);
      if (Number(isLiked)) {
        //취소
        localStorage.removeItem(article.id);
        firebase
          .database()
          .ref('article/')
          .child(article.id)
          .update({
            like: article.like - 1,
            updateDT: getTimeStamp(),
          });
      } else {
        //등록
        localStorage.setItem(article.id, 1);
        firebase
          .database()
          .ref('article/')
          .child(article.id)
          .update({
            like: article.like + 1,
            updateDT: getTimeStamp(),
          });

        if (article.like + 1 === 110) {
          //알람
          if (article.content.length > 10) {
            article.content = article.content.substring(0, 10) + '..';
          }
          firebase
            .database()
            .ref('user')
            .once('value', snapshot => {
              snapshot.forEach(childSnapshot => {
                var childData = childSnapshot.val();
                this.newLikePush('https://fcm.googleapis.com/fcm/send', childData, article.id, article.content); //백그라운드
              });
            });
        }
      }
    },
    newLikePush(url, token, id, content) {
      const message = {
        notification: {
          body: '[' + content + '] 게시글이 답변대기목록에 등록되었습니다',
          title: '마음의 소리',
          // "icon": "favicon.ico",
          click_action: 'https://voice-of-maxst.firebaseapp.com/detail/' + id,
        },
        to: token,
      };
      fetch(url, {
        method: 'POST',
        body: JSON.stringify(message),
        headers: new Headers({
          'Content-type': 'application/json',
          //     'Authorization' : 'key=AAAAQeYL0LE:APA91bEsNgjnX2QbogwvPxB5TN9K7eujE1IOU5-MYPPiGgvgNTr-6dEaO1z0KqtpBe-tHnfY9-X_AzMzKz1aB9GF5niU89vRCYtdj64mmQfbo1usR8Dy-EMcRyvUr-hvUBrqX6WubrfF'
          Authorization:
            'key=AAAAk9AA7y8:APA91bExjMQrMQsMdUJFghikTWE4I_2Qsb38V6PfZxjDhU3lKK6oNqlFr2lCCaljc7Yt2h1UTk438keq7vpo1CEudWm6jZONzJ_ldl9VPOMImPT8pPEKrklg643r6TWeZgUJ0vbESGpY',
        }),
      })
        .then(response => {
          if (response.status < 200 || response.status >= 400) {
            throw 'Error subscribing to topic: ' + response.status + ' - ' + response.text();
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    toggleShow: function() {
      this.showMenu = !this.showMenu;
    },
    moreRead(id) {
      event.stopPropagation();
      this.articleId = id;
    },
  },
};
</script>

<style scoped>
@import 'List.scss';
</style>
